import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  nurse: Yup.string().required("Nurse is required"),
  selectedFacility: Yup.string().required("Selected facility is required"),
  selectedUnit: Yup.string().required("Selected unit is required"),
  healthCareWorker: Yup.string().required("Health Care Worker is required"),
  precautions: Yup.string().required("Precautions is required"),
  totalQuestions: Yup.number()
    .integer("Total questions must be an integer")
    .min(0, "Total questions cannot be negative")
    .required("Total questions is required"),
  nonCompliantAnswers: Yup.number()
    .integer("nonCompliantQuestions must be an integer")
    .min(0, "nonCompliantQuestions cannot be negative")
    .required("nonCompliantQuestions is required"),
  nonCompliantWashRub: Yup.number()
    .integer("nonCompliantQuestions must be an integer")
    .min(0, "nonCompliantQuestions cannot be negative")
    .required("nonCompliantQuestions is required"),
  compliantAnswers: Yup.number()
    .integer("nonCompliantQuestions must be an integer")
    .min(0, "nonCompliantQuestions cannot be negative")
    .required("nonCompliantQuestions is required"),
  auditStrictCompliance: Yup.boolean().required(
    "Audit Strict Compliance is required"
  ),
  formQuestions: Yup.array().of(
    Yup.object().shape({
      stepTitle: Yup.string().required("Step title is required"),
      questions: Yup.array().of(
        Yup.object().shape({
          question: Yup.string().required("Question is required"),
          response: Yup.object().shape({
            value: Yup.string().required("Response value is required"),
            outcomeExists: Yup.boolean(),
            outcome: Yup.mixed().when(["outcomeExists"], {
              is: (outcomeExists) => {
                return outcomeExists === true;
              },
              then: Yup.object().shape({
                type: Yup.string().required("Outcome type is required"),
                value: Yup.string().required("Outcome value is required"),
              }),
              otherwise: Yup.object().notRequired(),
            }),
          }),
        })
      ),
    })
  ),
  comments: Yup.string().notRequired(),
  isTimerRunning: Yup.boolean().test(
    "additional-field-validation",
    "Timer is running",
    function (value) {
      return !value; // Return true if validation passes (additionalField is false)
    }
  ),
});
